module.exports = __webpack_public_path__ + "img/30.22436350.png";